// perf/CLS: only run the Swiper where the cards actually overflow — below the 1080 desktop
// breakpoint. At >=1080 all 5 categories fit in a row, so initialising Swiper there only added
// the stacked->row collapse shift, dead navigation arrows and needless JS. We now skip init on
// desktop entirely; the CSS `.category__v2--maininner:not(.swiper-initialized)` rules lay the 5
// cards out statically and pixel-identically (width: calc((100% - 76px)/5)). Init/destroy on the
// breakpoint change keeps a resized window correct.
document.addEventListener("DOMContentLoaded", function () {
  var el = document.querySelector(".category__v2--maininner");
  if (!el || typeof Swiper === "undefined") return;

  var instance = null;
  var mq = window.matchMedia("(max-width: 1079px)");
  var config = {
    slidesPerView: 1,
    spaceBetween: 0,
    scrollbar: {
      el: ".swiper-scrollbar.categoryv",
    },
    navigation: {
      nextEl: ".swiper-button-next.vcategory",
      prevEl: ".swiper-button-prev.vcategory",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 19,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 19,
      },
    },
  };

  function sync() {
    if (mq.matches) {
      if (!instance) instance = new Swiper(".category__v2--maininner", config);
    } else if (instance) {
      instance.destroy(true, true);
      instance = null;
    }
  }

  sync();
  if (mq.addEventListener) mq.addEventListener("change", sync);
  else if (mq.addListener) mq.addListener(sync);
});
